import React, { useState } from "react";
import { motion } from "framer-motion";
import quickcaptionGif from "../assets/quickcaption.gif"; // new gif
import downloadApp from "../assets/downloadapp.png";






export default function Hero() {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const x = (e.clientX / window.innerWidth - 0.5) * 20;
    const y = (e.clientY / window.innerHeight - 0.5) * 20;
    setMousePos({ x, y });
  };

  return (
    <section
      id="home"
      onMouseMove={handleMouseMove}
      className="relative flex flex-col-reverse md:flex-row items-center justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40 overflow-hidden"
    >
      {/* Text content */}
      <div className="w-full md:w-1/2 z-10">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl sm:text-5xl md:text-6xl font-extrabold mb-6 text-slate-900 dark:text-white leading-tight"
        >
          Create captions & hashtags{" "}
          <span className="text-indigo-500">effortlessly</span>.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-lg sm:text-xl text-slate-700 dark:text-slate-300 mb-8 max-w-lg"
        >
          Save time, get more reach with AI-generated captions and trending
          hashtags. Boost engagement with content that resonates instantly.
        </motion.p>

        {/* QR Code Section */}
    <motion.div
  initial={{ opacity: 0, scale: 0.9 }}
  animate={{ opacity: 1, scale: 1 }}
  transition={{ duration: 1, delay: 0.5 }}
  className="flex items-center gap-4 mb-8"
>
  {/* QR Placeholder with clickable link */}
  <a
    href="https://apps.apple.com/jp/app/quick-captionai/id6752661054?l=en-USQuick-CaptionAI"
    target="_blank"
    rel="noopener noreferrer"
    className="w-24 h-24 bg-white dark:bg-gray-800 rounded-xl shadow-md flex items-center justify-center border border-slate-300 dark:border-gray-600"
  >
    <img
      src={downloadApp}
      alt="QR Code"
      className="w-50 h-50"
    />
  </a>

  <p className="text-base sm:text-lg text-slate-700 dark:text-slate-300 max-w-xs">
    Scan the QR code to download the app directly to your iPhone.
  </p>
</motion.div>



        {/* CTA Buttons with hover animations */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4"
        >
        

          {/* Download App CTA */}
          <motion.a
            href="https://apps.apple.com/jp/app/quick-captionai/id6752661054?l=en-USQuick-CaptionAI"
            className="px-6 py-3 rounded-xl bg-white dark:bg-gray-800 dark:text-white text-slate-900 border border-slate-300 dark:border-gray-700 font-semibold flex items-center justify-center"
            whileHover={{
              scale: 1.05,
              boxShadow: "0px 6px 20px rgba(99,102,241,0.5)",
            }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 250 }}
          >
            Download App
          </motion.a>
        </motion.div>
      </div>

      {/* Hero Illustration + Blobs + Interactive Shapes */}
      <div className="w-full md:w-1/2 flex justify-center mb-10 md:mb-0 relative">
        {/* New GIF above circle */}
       <motion.img
  src={quickcaptionGif}
  alt="QuickCaption Animation"
  className="hidden md:block absolute top-[-350px] left-2/2 transform -translate-x-1/2 w-72 md:w-96 z-20"
  initial={{ opacity: 0, scale: 0.95 }}
  animate={{
    opacity: 1,
    scale: 1,
    y: [0, -20, 0], // floating up & down
  }}
  transition={{
    duration: 6, // slow animation
    repeat: Infinity,
    repeatType: "loop",
    ease: "easeInOut",
  }}
/>



        {/* Large animated blobs */}
        <motion.div
          style={{ x: mousePos.x * 0.5, y: mousePos.y * 0.5 }}
          className="absolute w-72 h-72 md:w-96 md:h-96 bg-gradient-to-tr from-indigo-400 via-pink-400 to-yellow-400 rounded-full filter blur-3xl opacity-40 animate-blob"
        />
        <motion.div
          style={{ x: -mousePos.x * 0.3, y: -mousePos.y * 0.3 }}
          className="absolute w-40 h-40 bg-pink-300 rounded-full opacity-40 filter blur-2xl top-20 right-10 animate-blob animation-delay-2000"
        />

        {/* Small interactive shapes */}
        {[
          { top: "10%", left: "20%", color: "bg-yellow-400", size: 6 },
          { top: "32%", right: "16%", color: "bg-indigo-300", size: 8 },
          { bottom: "20%", left: "10%", color: "bg-pink-400", size: 5 },
        ].map((shape, idx) => (
          <motion.div
            key={idx}
            style={{
              width: `${shape.size}rem`,
              height: `${shape.size}rem`,
              top: shape.top,
              left: shape.left,
              right: shape.right,
              bottom: shape.bottom,
              x: mousePos.x * 0.2,
              y: -mousePos.y * 0.2,
            }}
            className={`${shape.color} absolute rounded-full opacity-60`}
            animate={{ scale: 1 }}
            whileHover={{ scale: 1.5, rotate: 15 }}
            transition={{ type: "spring", stiffness: 100 }}
          />
        ))}

        {/* Hero Illustration (your main static icon) */}
      </div>
    </section>
  );
}
